<template>
  <v-container fluid>

    <ConfirmDialog
        :is-open.sync="dialogs.bindCustomerDialog.isOpened"
        :is-disable-confirm-button="!getDialogData(
            'bindCustomerDialog', 'customerIds'
        )"
        width="400"
        confirm-button-text="Bind"
        @confirm="bindCustomer"
    >
      <template v-slot:title>
        Select customer:
      </template>
      <template v-slot:body>
        <v-row>
          for composite customer:
        </v-row>
        <v-row class="font-weight-bold">
          {{ getDialogData('bindCustomerDialog', 'compositeCustomerName') }}
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
                item-text="label"
                item-value="id"
                label="customers"
                clearable
                dense
                chips
                small-chips
                multiple
                v-model="dialogs.bindCustomerDialog.data.customerIds"
                :items="customersList"
                :menu-props="{ closeOnContentClick: true }"
            />
          </v-col>
        </v-row>
      </template>
    </ConfirmDialog>

    <ConfirmDialog
        :is-open.sync="dialogs.unbindCustomerDialog.isOpened"
        width="400"
        confirm-button-text="Unbind"
        @confirm="unbindCustomer"
    >
      <template v-slot:title>
        Unbind customer:
        <span class="font-weight-bold ml-4">
          {{ currentCustomer(getDialogData('unbindCustomerDialog', 'customerId')).name }}
        </span>
      </template>
      <template v-slot:body>
        <v-row>
          for composite customer:
        </v-row>
        <v-row class="font-weight-bold">
          {{ getDialogData('unbindCustomerDialog', 'compositeCustomerName') }}
        </v-row>
      </template>
    </ConfirmDialog>

    <ConfirmDialog
        :is-open.sync="dialogs.setDashboard.isOpened"
        width="400"
        confirm-button-text="Set"
        @confirm="setDashboard"
    >
      <template v-slot:title>
        Add dashboard:
      </template>
      <template v-slot:body>
        <v-row>
          for composite customer:
        </v-row>
        <v-row class="font-weight-bold">
          {{ getDialogData('setDashboard', 'compositeCustomerName') }}
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
                item-text="name"
                item-value="id"
                label="dashboard"
                dense
                chips
                small-chips
                v-model="dialogs.setDashboard.data.dashboardId"
                :items="dashboards"
                :menu-props="{ closeOnContentClick: true }"
            />
          </v-col>
        </v-row>
      </template>
    </ConfirmDialog>

    <ConfirmDialog
        :is-open.sync="dialogs.removeDashboard.isOpened"
        width="400"
        confirm-button-text="Remove"
        @confirm="removeDashboard"
    >
      <template v-slot:title>
        Remove dashboard:
      </template>
      <template v-slot:body>
        <v-row>
          for composite customer:
        </v-row>
        <v-row class="font-weight-bold">
          {{ getDialogData('removeDashboard', 'compositeCustomerName') }}
        </v-row>
        <v-row>
          dashboard:
        </v-row>
        <v-row class="font-weight-bold">
          {{ getDialogData('removeDashboard', 'dashboardName') }}
        </v-row>
      </template>
    </ConfirmDialog>

    <v-data-table
        :options.sync="options"
        :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
        :headers="headers"
        :items="filteredCompositeCustomers"
        :single-expand="true"
    >
      <template v-slot:top>
        <v-toolbar
            class="mt-4"
            flat
        >
          <CompositeCustomerForm v-on:create="addCompositeCustomer" />

          <v-btn
              icon
              outlined
              @click="refreshData"
          >
            <v-tooltip
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                >
                  mdi-refresh
                </v-icon>
              </template>
              refresh composite customer list
            </v-tooltip>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:body.prepend>
        <tr class="table-filter-row">
          <td>
            <v-text-field
                v-model="filters.id"
                placeholder="id"
                dense
                outlined
                clearable
                hide-details
                class="table-column-filter"
            />
          </td>
          <td />
          <td>
            <v-text-field
                v-model="filters.name"
                placeholder="name"
                dense
                outlined
                clearable
                hide-details
                class="table-column-filter"
            />
          </td>
          <td />
          <td>
            <v-autocomplete
                v-model="filters.customers"
                :items="customerFilterOptions"
                :filter="relationFilterSearch"
                :menu-props="{ closeOnContentClick: true }"
                dense
                outlined
                clearable
                hide-details
                multiple
                chips
                small-chips
                deletable-chips
                :search-input.sync="relationSearch.customers"
                @change="onRelationFilterChange('customers', $event)"
                class="table-column-filter"
            />
          </td>
          <td>
            <v-autocomplete
                v-model="filters.dashboard"
                :items="dashboardFilterOptions"
                :filter="relationFilterSearch"
                :menu-props="{ closeOnContentClick: true }"
                dense
                outlined
                clearable
                hide-details
                multiple
                chips
                small-chips
                deletable-chips
                :search-input.sync="relationSearch.dashboard"
                @change="onRelationFilterChange('dashboard', $event)"
                class="table-column-filter"
            />
          </td>
          <td>
            <v-select
                v-model="filters.isVisible"
                :items="booleanFilterItems"
                :menu-props="{ closeOnContentClick: true }"
                item-text="text"
                item-value="value"
                dense
                outlined
                clearable
                hide-details
                class="table-column-filter"
            />
          </td>
          <td>
            <v-select
                v-model="filters.isNative"
                :items="booleanFilterItems"
                :menu-props="{ closeOnContentClick: true }"
                item-text="text"
                item-value="value"
                dense
                outlined
                clearable
                hide-details
                class="table-column-filter"
            />
          </td>
          <td>
            <v-select
                v-model="filters.isActive"
                :items="booleanFilterItems"
                :menu-props="{ closeOnContentClick: true }"
                item-text="text"
                item-value="value"
                dense
                outlined
                clearable
                hide-details
                class="table-column-filter"
            />
          </td>
          <td />
        </tr>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="remove(item.id)">
          <v-icon
              color="red"
          >
            mdi-delete
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.name="{ item }">
        <v-row>
          <v-edit-dialog
              @save="save(itemClone, item)"
              @open="itemClone = {...item}"
          >
            {{ item.name }}
            <template v-slot:input>
              <v-text-field
                  v-model="itemClone.name"
                  label="Edit"
                  single-line
                  counter
              />
            </template>
          </v-edit-dialog>
        </v-row>
      </template>

      <template v-slot:item.order="{ item }">
        <v-row>
          <v-edit-dialog
              @save="updateItemOrder(itemClone)"
              @open="itemClone = {...item}"
          >
            {{ item.order }}
            <template v-slot:input>
              <v-text-field
                  v-model="itemClone.order"
                  type="number"
                  label="Order"
                  single-line
                  counter
              />
            </template>
          </v-edit-dialog>
        </v-row>
      </template>

      <template v-slot:item.description="{ item }">
        <v-edit-dialog
            @save="save(itemClone, item)"
            @open="itemClone = {...item}"
        >
          <div v-if="item.description" class="font-weight-black">{{ item.description }}</div>
          <div v-else class="font-italic font-weight-thin red--text" v-text="'empty'"/>
          <template v-slot:input>
            <v-text-field
                v-model="itemClone.description"
                label="Edit"
                single-line
                counter
            />
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.customers="{ item }">
        <v-btn
            text
            color="teal accent-4"
            fab
            small
            @click="openDialog(
                'bindCustomerDialog',
                {
                  compositeCustomerName: item.name,
                  compositeCustomerId: item.id,
                },
            )"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-label
                </v-icon>
            </template>
            add customer
          </v-tooltip>
        </v-btn>
        <v-chip
            v-for="customer in item.customers"
            :key="customer.id"
            close
            @click:close="openDialog(
                'unbindCustomerDialog',
                {
                  compositeCustomerName: item.name,
                  compositeCustomerId: item.id,
                  customerId: customer.id,
                },
              )"
            class="ma-0"
            :color="customer.is_airport ? '#FF6E40' : '#c49c18'"
            small
        >
          {{ customer.name }}
          {{ customer.is_airport ? '(is apt)' : '' }}
        </v-chip>
      </template>

      <template v-slot:item.dashboard="{ item }">
        <v-btn
            text
            color="teal accent-4"
            fab
            small
            @click="openDialog(
                'setDashboard',
                {
                  compositeCustomerName: item.name,
                  compositeCustomerId: item.id,
                },
            )"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <slot>
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-label
                </v-icon>
              </slot>
            </template>
            add dashboard
          </v-tooltip>
        </v-btn>
        <v-chip
            v-for="dashboard in item.dashboards"
            :key="dashboard.id"
            close
            @click:close="openDialog(
                'removeDashboard',
                {
                  compositeCustomerName: item.name,
                  compositeCustomerId: item.id,
                  dashboardId: dashboard.id,
                  dashboardName: dashboard.name,
                },
              )"
            class="ma-0"
            small
        >
          {{ dashboard.name }}
        </v-chip>
        <span
            v-if="!item.dashboards.length"
            class="font-italic font-weight-thin red--text"
        >
          empty
        </span>
      </template>

      <template v-slot:item.is_visible="{ item }">
        <v-switch
            v-model="item.is_visible"
            @change="save(item, item)"
        />
      </template>

      <template v-slot:item.is_active="{ item }">
        <v-switch
            v-model="item.is_active"
            @change="save(item, item)"
        />
      </template>

      <template v-slot:item.is_native="{ item }">
        <v-switch
            v-model="item.is_native"
            @change="save(item, item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import CompositeCustomerForm from '../components/CompositeCustomerForm.vue';
import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue';
import manageDialogsMixin from '../mixins/manageDialogsMixin';
import relationFilter from '../mixins/relationFilter';

export default {
  name: 'LogVersion',
  components: {
    CompositeCustomerForm,
    ConfirmDialog,
  },

  mixins: [
    manageDialogsMixin,
    relationFilter,
  ],

  data: () => ({
    itemClone: {},
    compositeCustomers: [],
    customersList: [],
    dashboards: [],

    headers: [
      { text: 'id', value: 'id', width: '112px' },
      { text: 'order', value: 'order' },
      { text: 'name', value: 'name' },
      { text: 'description', value: 'description' },
      { text: 'customers', value: 'customers' },
      { text: 'dashboard', value: 'dashboard', width: '260px' },
      { text: 'is visible', value: 'is_visible', width: '120px' },
      { text: 'is native', value: 'is_native', width: '88px' },
      { text: 'is active', value: 'is_active', width: '88px' },
      { text: '', value: 'actions', sortable: false },
    ],
    options: {
      itemsPerPage: 10,
      sortBy: ['order'],
      sortDesc: [false],
      mustSort: true,
      multiSort: false,
    },
    filters: {
      id: '',
      name: '',
      customers: null,
      dashboard: null,
      isVisible: null,
      isNative: null,
      isActive: null,
    },
    relationSearch: {
      customers: null,
      dashboard: null,
    },
    booleanFilterItems: [
      { text: 'Yes', value: true },
      { text: 'No', value: false },
    ],

    dialogs: {
      bindCustomerDialog: {
        isOpened: false,
        data: {
          compositeCustomerName: '',
          customerIds: [],
          compositeCustomerId: null,
        },
        defaults: {
          compositeCustomerName: '',
          customerIds: [],
          compositeCustomerId: null,
        },
      },

      unbindCustomerDialog: {
        isOpened: false,
        data: {
          compositeCustomerName: '',
          customerId: null,
          compositeCustomerId: null,
        },
        defaults: {
          compositeCustomerName: '',
          customerId: null,
          compositeCustomerId: null,
        },
      },

      setDashboard: {
        isOpened: false,
        data: {
          compositeCustomerName: '',
          compositeCustomerId: null,
          dashboardId: null,
        },
        defaults: {
          compositeCustomerName: '',
          compositeCustomerId: null,
          dashboardId: null,
        },
      },

      removeDashboard: {
        isOpened: false,
        data: {
          compositeCustomerName: '',
          compositeCustomerId: null,
          dashboardId: null,
          dashboardName: '',
        },
        defaults: {
          compositeCustomerName: '',
          compositeCustomerId: null,
          dashboardId: null,
          dashboardName: '',
        },
      },
    },
  }),

  created() {
    this.fetchCustomersList();

    this.fetchDashboards();

    this.fetchCompositeCustomers();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    matchFilter(value, filter) {
      if (!filter) return true;
      return String(value).toLowerCase().includes(String(filter).toLowerCase());
    },

    parseIdFilterValues(filter) {
      return String(filter || '')
        .trim()
        .split(/[\s,]+/)
        .map((value) => value.trim())
        .filter(Boolean);
    },

    matchIdFilter(value, filter) {
      const filterValues = this.parseIdFilterValues(filter);

      if (!filterValues.length) return true;

      return filterValues.includes(String(value ?? '').trim());
    },

    toBool(value) {
      if (value === true || value === 1 || value === '1') return true;
      if (value === false || value === 0 || value === '0') return false;
      return null;
    },

    async refreshData() {
      this.fetchCustomersList();

      this.fetchDashboards();

      this.fetchCompositeCustomers();
    },

    async fetchCompositeCustomers() {
      await this.$requestHelpers
        .get('api/admin/compositeCustomer')
        .then((response) => {
          // eslint-disable-next-line max-len
          this.compositeCustomers = response.data.map((item) => this.normalizeCompositeCustomer(item));
        }).catch((error) => {
          if (error.response) {
            if (error.response.status === 403) {
              this.$router.push({ name: 'root' });
            }
          }
        });
    },

    addCompositeCustomer(compositeCustomer) {
      this.compositeCustomers.push(this.normalizeCompositeCustomer(compositeCustomer));
    },

    normalizeCompositeCustomer(item) {
      let dashboards = [];

      if (Array.isArray(item.dashboards)) {
        dashboards = item.dashboards;
      } else if (item.dashboard && item.dashboard.id) {
        dashboards = [item.dashboard];
      }

      return {
        ...item,
        dashboards,
        dashboard: dashboards[0] || { id: null, name: 'n/a' },
        dashboard_id: dashboards[0] ? dashboards[0].id : null,
        is_visible: item.is_visible !== false,
      };
    },

    save(itemClone, item) {
      this.$requestHelpers
        .patch(`api/admin/compositeCustomer/${item.id}`, itemClone)
        .then((response) => {
          if (response.data.success) {
            Object.assign(item, this.normalizeCompositeCustomer(response.data.result));

            this.setSnack({
              color: 'green',
              text: 'saved',
            });
          } else {
            this.setSnack({
              color: 'red',
              text: response.data.message,
            });
          }
        });
    },

    updateItemOrder(itemClone) {
      this.$requestHelpers
        .post('api/admin/compositeCustomer/updateOrder',
          {
            id: itemClone.id,
            order: itemClone.order,
          })
        .then((response) => {
          if (response.data.success) {
            response.data.result.forEach((el) => {
              const compositeCustomer = this.compositeCustomers.find((item) => item.id === el.id);

              compositeCustomer.order = el.order;
            });

            this.setSnack({
              color: 'green',
              text: 'saved',
            });
          }
        });
    },

    remove(id) {
      const compositeCustomer = this.compositeCustomers.find((el) => el.id === id);
      this.$confirm(`Are you sure you want to delete composite customer ${compositeCustomer.name}?`).then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/compositeCustomer/${id}`)
          .then((response) => {
            if (response.data.success) {
              this.setSnack({
                color: 'green',
                text: 'deleted',
              });
              this.compositeCustomers = this.compositeCustomers.filter((e) => e.id !== id);
            } else {
              this.setSnack({
                color: 'red',
                text: 'error',
              });
            }
          });
      });
    },

    bindCustomer() {
      this.$requestHelpers
        .post('api/admin/compositeCustomer/bindCustomers',
          {
            composite_customer_id: this.getDialogData('bindCustomerDialog', 'compositeCustomerId'),
            customer_ids: this.getDialogData('bindCustomerDialog', 'customerIds'),
          }).then((response) => {
          const item = this.compositeCustomers.find((el) => el.id === response.data.result.id);

          Object.assign(item, this.normalizeCompositeCustomer(response.data.result));
        }).finally(() => {
          this.closeDialog('bindCustomerDialog');
        });
    },

    unbindCustomer() {
      this.$requestHelpers
        .post('api/admin/compositeCustomer/unbindCustomer',
          {
            composite_customer_id: this.getDialogData('unbindCustomerDialog', 'compositeCustomerId'),
            customer_id: this.getDialogData('unbindCustomerDialog', 'customerId'),
          }).then((response) => {
          const item = this.compositeCustomers.find((el) => el.id === response.data.result.id);

          Object.assign(item, this.normalizeCompositeCustomer(response.data.result));
        }).finally(() => {
          this.closeDialog('unbindCustomerDialog');
        });
    },

    setDashboard() {
      this.$requestHelpers
        .post('api/admin/compositeCustomer/setDashboard',
          {
            composite_customer_id: this.getDialogData('setDashboard', 'compositeCustomerId'),
            dashboard_id: this.getDialogData('setDashboard', 'dashboardId'),
          }).then((response) => {
          const item = this.compositeCustomers.find((el) => el.id === response.data.result.id);

          Object.assign(item, this.normalizeCompositeCustomer(response.data.result));
        }).finally(() => {
          this.closeDialog('setDashboard');
        });
    },

    removeDashboard() {
      this.$requestHelpers
        .post('api/admin/compositeCustomer/removeDashboard',
          {
            composite_customer_id: this.getDialogData('removeDashboard', 'compositeCustomerId'),
            dashboard_id: this.getDialogData('removeDashboard', 'dashboardId'),
          }).then((response) => {
          const item = this.compositeCustomers.find((el) => el.id === response.data.result.id);

          Object.assign(item, this.normalizeCompositeCustomer(response.data.result));
        }).finally(() => {
          this.closeDialog('removeDashboard');
        });
    },

    fetchCustomersList() {
      this.$requestHelpers
        .get('api/admin/customer')
        .then((response) => {
          this.customersList = response.data.map(
            (el) => ({
              id: el.id,
              name: el.name,
              label: (el.is_airport
                ? `${el.name} - is airport`
                : el.name),
            }),
          );
        });
    },

    fetchDashboards() {
      this.$requestHelpers.get('api/admin/dashboard/list')
        .then((response) => {
          this.dashboards = response.data;
        });
    },
  },

  computed: {
    filteredCompositeCustomers() {
      return this.compositeCustomers.filter((item) => {
        const id = String(item.id || '');
        const name = String(item.name || '');
        const customerNames = (item.customers || []).map((el) => el.name);
        const dashboardNames = (item.dashboards || []).map((el) => el.name);
        const customersMatched = this.matchRelationFilter(this.filters.customers, customerNames);
        const dashboardsMatched = this.matchRelationFilter(this.filters.dashboard, dashboardNames);
        const isVisibleMatched = this.filters.isVisible === null
          ? true
          : this.toBool(item.is_visible) === this.filters.isVisible;
        const isNativeMatched = this.filters.isNative === null
          ? true
          : this.toBool(item.is_native) === this.filters.isNative;
        const isActiveMatched = this.filters.isActive === null
          ? true
          : this.toBool(item.is_active) === this.filters.isActive;

        return this.matchIdFilter(id, this.filters.id)
          && this.matchFilter(name, this.filters.name)
          && customersMatched
          && dashboardsMatched
          && isVisibleMatched
          && isNativeMatched
          && isActiveMatched;
      });
    },

    customerFilterOptions() {
      return this.relationFilterOptions(this.customersList.map((item) => item.name));
    },

    dashboardFilterOptions() {
      return this.relationFilterOptions(this.dashboards.map((item) => item.name));
    },

    currentCustomer() {
      return (id) => {
        const item = this.customersList.find((el) => el.id === id);
        return item || { id: null, name: 'n/a' };
      };
    },
  },
};
</script>

<style scoped>
.table-filter-row > td {
  padding: 4px 8px !important;
}

.table-column-filter {
  max-width: 100%;
}
</style>
